import React, { useRef } from 'react';
import FormCard from 'pages/NewUniProfile/components/FormCard';
import ConsentFormsStep, { ConsentFormsStepHandles } from 'pages/PaymentSetup/components/ConsentFormsStep';
import s from './s.module.less';

interface Props {
    initValue?: any;
    onSave?: () => void;
}

const ConsentForms: React.FC<Props> = (props) => {
    const { onSave } = props;
    const consentFormsStepRef = useRef<ConsentFormsStepHandles>(null);

    const handleSave = async () => {
        try {
            await consentFormsStepRef.current?.onSubmit();
            onSave?.();
        } catch (error) {
            console.error('Form save failed:', error);
            throw error;
        }
    };

    const renderEditing = () => {
        return (
            <div className={s.editingContainer}>
                <ConsentFormsStep
                    ref={consentFormsStepRef}
                    isEdit={true}
                    isReview={true}
                    type="onboarding"
                />
            </div>
        );
    };

    const renderReview = () => {
        return (
            <div className={s.reviewContainer}>
                <ConsentFormsStep
                    isEdit={false}
                    isReview={true}
                    type="onboarding"
                />
            </div>
        );
    };

    return (
        <FormCard type='review' title='Consent forms' hasContent={true} onSave={handleSave}>
            {(isEditing) => isEditing ? renderEditing() : renderReview()}
        </FormCard>
    );
};

export default ConsentForms;

